/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-useless-escape */

// 郵便番号のバリデーションを行う
export const validatePostalCode = (
  postalCode: string
): {
  hasErrorEmptyPostalCode: boolean;
  hasErrorIncorrectPostalCode: boolean;
} => {
  const hasErrorEmptyPostalCode = postalCode === "";

  const hasErrorIncorrectPostalCode =
    postalCode.match(/^[a-zA-Z0-9]*$/)?.length !== 1;

  return {
    hasErrorEmptyPostalCode,
    hasErrorIncorrectPostalCode,
  };
};
